import { Search, X } from 'lucide-react';
import { useT } from '../../i18n';

/** Large search box with a clear button (used by the directory and admin member list). */
export function SearchField({ value, onChange, placeholder }: { value: string; onChange: (v: string) => void; placeholder: string }) {
  const t = useT();
  return (
    <div className="relative">
      <Search className="pointer-events-none absolute top-1/2 left-4 size-5 -translate-y-1/2 text-[var(--muted)]" aria-hidden />
      <input
        type="search"
        inputMode="search"
        enterKeyHint="search"
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        className="min-h-12 w-full rounded-2xl border border-[var(--line)] bg-[var(--surface)] py-3 pr-14 pl-12 text-[17px] text-[var(--ink)] placeholder:text-[var(--muted)] focus:border-[var(--focus)] focus:ring-2 focus:ring-[var(--focus)]/30 focus:outline-none [&::-webkit-search-cancel-button]:hidden"
      />
      {value ? (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label={t('choir.search_clear')}
          className="absolute top-1/2 right-1 inline-flex size-11 -translate-y-1/2 items-center justify-center rounded-xl text-[var(--muted)] hover:bg-[var(--accent-soft)]"
        >
          <X className="size-5" aria-hidden />
        </button>
      ) : null}
    </div>
  );
}
